export default class CollapseHandler {
    resizeTimer;

    constructor(){
        document.addEventListener("DOMContentLoaded", () => {
            this.getScrollHeight();
        })

        window.addEventListener("resize", (e) => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.getScrollHeight();
            }, 250);
        });

        window.getScrollHeight = this.getScrollHeight;
    }

    getScrollHeight() {
        document.querySelectorAll(".scrollHeight").forEach((elm) => {
            elm.style.height = elm.scrollHeight + "px";
        });
    }
}